import { FaCheckDouble, FaSave } from 'react-icons/fa';
import SettingsCard from './SettingsCard';

const ActionsSection = ({
  data,
  selectedActionIds,
  onToggle,
  onSave,
  maxSelectable,
  hasChanges = false,
}) => {
  const { title, description, items } = data;
  const selectedSet = selectedActionIds ?? new Set();
  const limit = maxSelectable ?? Infinity;
  const selectedCount = selectedSet.size;

  return (
    <SettingsCard title={title} description={description}>
      <div className="space-y-5">
        <div className="grid gap-4 sm:grid-cols-3">
          {items.map((action) => {
            const isSelected = selectedSet.has(action.id);
            const isDisabled = !isSelected && selectedCount >= limit;
            const baseClasses =
              'flex items-center justify-between rounded-2xl border px-4 py-3 text-sm font-semibold transition-all duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-customAccent focus-visible:ring-offset-2 focus-visible:ring-offset-customSurface';
            const selectedClasses =
              'border-customAccent bg-customAccent text-white shadow-lg hover:-translate-y-0.5';
            const idleClasses =
              'border-transparent bg-customSurfaceMuted text-customHeading hover:-translate-y-0.5 hover:border-customAccent hover:bg-customSurface hover:text-white';
            const disabledClasses = isDisabled
              ? 'cursor-not-allowed opacity-60 hover:-translate-y-0 hover:border-transparent hover:bg-customSurfaceMuted hover:text-customHeading'
              : '';
            return (
              <button
                key={action.id}
                type="button"
                onClick={() => {
                  if (isDisabled) return;
                  onToggle?.(action.id);
                }}
                disabled={isDisabled}
                aria-pressed={isSelected}
                title={
                  isSelected
                    ? 'Click to remove from quick actions'
                    : isDisabled
                    ? `You can only select ${limit} actions`
                    : 'Click to add to quick actions'
                }
                className={[
                  baseClasses,
                  isSelected ? selectedClasses : idleClasses,
                  disabledClasses,
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                <span>{action.label}</span>
                <FaCheckDouble
                  className={`h-4 w-4 transition-opacity duration-200 ${
                    isSelected ? 'opacity-100 text-white' : 'opacity-0 text-customMuted'
                  }`}
                  aria-hidden="true"
                />
              </button>
            );
          })}
        </div>

        <div className="flex justify-end">
          <button
            type="button"
            onClick={onSave}
            disabled={!hasChanges}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-customAccent px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-customAccent/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-customAccent focus-visible:ring-offset-2 focus-visible:ring-offset-customSurface disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-customAccent"
          >
            <FaSave className="h-4 w-4" aria-hidden="true" />
            Save Changes
          </button>
        </div>
      </div>
    </SettingsCard>
  );
};

export default ActionsSection;
